import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { getToken } from '../../utils/auth';

const AdminGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const navigate = useNavigate();
    const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

    useEffect(() => {
        const checkAuth = () => {
            const token = getToken();
            if (!token) {
                toast.error('Vui lòng đăng nhập để tiếp tục');
                setIsAuthorized(false);
                return;
            }

            try {
                // Decode JWT payload (standard format: header.payload.signature)
                const payload = JSON.parse(atob(token.split('.')[1]));
                if (payload.role === 'admin') {
                    setIsAuthorized(true);
                } else {
                    toast.error('Bạn không có quyền truy cập trang này!');
                    setIsAuthorized(false);
                }
            } catch (e) {
                console.error('Invalid token:', e);
                toast.error('Phiên đăng nhập không hợp lệ');
                setIsAuthorized(false);
            }
        };

        checkAuth();
    }, []);

    if (isAuthorized === null) {
        // Render nothing or a spinner while checking
        return null;
    }

    if (!isAuthorized) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default AdminGuard;
